"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserRsaProviderKeyFactory = void 0;

var _uuid = require("uuid");

var _utils = require("../utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BrowserRsaProviderKeyFactory = /*#__PURE__*/function () {
  function BrowserRsaProviderKeyFactory(provKeyRepo, keyRepo, rsaKeySize) {
    _classCallCheck(this, BrowserRsaProviderKeyFactory);

    _defineProperty(this, "provider", 'BROWSER');

    _defineProperty(this, "algorithm", 'RSA');

    _defineProperty(this, "_provKeyRepo", void 0);

    _defineProperty(this, "_keyRepo", void 0);

    _defineProperty(this, "_rsaKeySize", void 0);

    this._provKeyRepo = provKeyRepo;
    this._keyRepo = keyRepo;
    this._rsaKeySize = rsaKeySize;
  }

  _createClass(BrowserRsaProviderKeyFactory, [{
    key: "getOrCreateKey",
    value: function getOrCreateKey(name) {
      var _this = this;

      return this._provKeyRepo.getKeyByName(name, this.provider, this.algorithm).catch(function () {
        return _this.createKey(name);
      });
    }
  }, {
    key: "getKeyByKeyId",
    value: function getKeyByKeyId(keyId) {
      return this._provKeyRepo.getKeyByKeyId(keyId);
    }
  }, {
    key: "createKey",
    value: function () {
      var _createKey = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
        var keyPair, exportedPublic, exportedPrivate, rsaKey, provKeyId, provKey;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return window.crypto.subtle.generateKey((0, _utils.getBrowserRsaParams)(this._rsaKeySize), true, ['encrypt', 'decrypt']);

              case 2:
                keyPair = _context.sent;

                if (!(typeof keyPair.publicKey === 'undefined' || typeof keyPair.privateKey === 'undefined')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Promise.reject('Error when creating browser RSA key.'));

              case 5:
                _context.next = 7;
                return window.crypto.subtle.exportKey('spki', keyPair.publicKey);

              case 7:
                exportedPublic = _context.sent;
                _context.next = 10;
                return window.crypto.subtle.exportKey('pkcs8', keyPair.privateKey);

              case 10:
                exportedPrivate = _context.sent;
                rsaKey = (0, _utils.rsaBufferTokeyId)(exportedPublic, exportedPrivate);
                provKeyId = (0, _uuid.v4)();

                this._keyRepo.save(provKeyId, rsaKey);

                provKey = {
                  name: name,
                  provider: this.provider,
                  providerKeyId: provKeyId,
                  algorithm: this.algorithm
                };
                return _context.abrupt("return", this._provKeyRepo.saveKey(provKey));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createKey(_x) {
        return _createKey.apply(this, arguments);
      }

      return createKey;
    }()
  }]);

  return BrowserRsaProviderKeyFactory;
}();

exports.BrowserRsaProviderKeyFactory = BrowserRsaProviderKeyFactory;